import { useEffect, useState } from "react";
import AccountSettings from "./AccountSettings.tsx";
import OrderList from "./OrderList.tsx";
import { AddProduct } from "./AddProduct.tsx";
import CategoryList from "./CategoryList.tsx";
import Overview from "./Overview.tsx";
import ProductTable from "./ProductTable.tsx";
import styles from "./AdminDashboard.module.css";
import { Product } from "../../models/product.ts";
import { useDispatch, useSelector } from "react-redux";
import { getAdminProfile } from "../../Services/admin.service.ts";

const TABS = ["Overview", "Products", "Orders", "Categories", "Account"];

const AdminDashboard = () => {
  // ...existing code...
  const [activeTab, setActiveTab] = useState(TABS[0]);
  const [editingProduct, setEditingProduct] = useState<Product | undefined>(
    undefined
  );
  const [showAddProduct, setShowAddProduct] = useState(false);
  const dispatch = useDispatch();
  const { isAuthenticated, username } = useSelector((state: any) => state.auth);

  useEffect(() => {
    getAdminProfile();
  }, []);

  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className={styles.dashboardWrapper}>
      <div className={styles.dashboardHeader}>
        <a href="/" className={styles.wordmark} aria-label="Ayzen home">
          <img src="/assets/logo.png" alt="Ayzen" />
        </a>
        <div className={styles.headerActions}>
          {username && (
            <button
              type="button"
              className={styles.userChip}
              onClick={() => setActiveTab("Account")}
            >
              {username}
            </button>
          )}
          <button onClick={handleLogout} className={styles.logoutButton}>
            Logout
          </button>
        </div>
      </div>
      <div className={styles.dashboardBody}>
        <div className={styles.sidebar}>
          {TABS.map((tab) => (
            <div
              key={tab}
              onClick={() => {
                setActiveTab(tab);
                setShowAddProduct(false);
              }}
              className={
                activeTab === tab
                  ? `${styles.tab} ${styles.activeTab}`
                  : styles.tab
              }
            >
              {tab}
            </div>
          ))}
        </div>
        <div className={styles.tabContent}>
          {activeTab === "Overview" && (
            <Overview onOpenOrders={() => setActiveTab("Orders")} />
          )}
          {activeTab === "Products" && !showAddProduct && (
            <ProductTable
              onAddProduct={() => {
                setShowAddProduct(true);
                setEditingProduct(undefined);
              }}
              onEditProduct={(product) => {
                setEditingProduct(product);
                setShowAddProduct(true);
              }}
            />
          )}
          {activeTab === "Products" && showAddProduct && (
            <AddProduct
              productToEdit={editingProduct}
              onBack={() => {
                setShowAddProduct(false);
                setEditingProduct(undefined);
              }}
            />
          )}
          {activeTab === "Orders" && <OrderList />}
          {activeTab === "Categories" && <CategoryList />}
          {activeTab === "Account" && <AccountSettings />}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
